/* Responsibility: Set title in window based on selected destination filter. Also implemented on server side (TitleLocationMaker.java)  */
import preconditions from '../lib/preconditions.js';

const checkPreconditions = preconditions('locationTitle', {
    resultViewCriteria: 'object',
    eventHub: 'eventHub',
    browserWindow: 'object',
    siteName: 'string',
});

export default function setupLocationTitle(params) {
    checkPreconditions(params);

    function setTitle(locationTitle) {
        params.browserWindow.document.title = `${params.siteName} - ${locationTitle} | FINN reise`;
    }

    function filtersChanged() {
        const filter = params.resultViewCriteria.til;
        if (!filter || !filter.length) {
            setTitle('sammenlign pris');
        } else {
            const locationSplit = filter[filter.length - 1].split(';');
            setTitle(locationSplit[1] + (locationSplit.length > 2 ? `, ${locationSplit.pop()}` : ''));
        }
    }

    params.eventHub.subscribe('resultViewCriteria:changed', filtersChanged);
}
